import { API_ENDPOINTS, createApiUrl, ServiceType } from 'src/contstant/apiEndpoints';
import { apiClient } from '../apiClient';
import {
  ListTasksRequest,
  ListTasksResponse,
  GetTaskRequest,
  GetTaskResponse,
  GetTaskStatsRequest,
  GetTaskStatsResponse,
  AssigneeUpdateTaskRequest,
  AssigneeUpdateTaskResponse,
  AuditorUpdateTaskRequest,
  AuditorUpdateTaskResponse,
  CancelTaskRequest,
  CancelTaskResponse,
  SearchTasksRequest,
  SearchTasksResponse,
  CreateTaskRequest,
  CreateTaskResponse,
  CreateTaskFromQuestionRequest,
  CreateTaskFromQuestionResponse,
  ReopenTaskRequest,
  ReopenTaskResponse,
} from 'src/types/helios/Task';

export const tasksService = {
  // Get all tasks
  list: async (data: ListTasksRequest): Promise<ListTasksResponse> => {
    let allTasks: any[] = [];
    let nextToken = data.nextToken;

    do {
      const requestData = { ...data, nextToken };
      const response = await apiClient.get<ListTasksResponse>(
        ServiceType.HELIOS,
        createApiUrl(API_ENDPOINTS.HELIOS_SERVICE.TASKS.LIST(data.businessUnitId)),
        requestData,
      );

      allTasks = allTasks.concat(response.tasks);
      nextToken = response.nextToken;
    } while (nextToken);

    return { tasks: allTasks, nextToken: undefined };
  },
  // Get single task
  get: (data: GetTaskRequest) => {
    return apiClient.get<GetTaskResponse>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.TASKS.GET(data.businessUnitId, data.taskId),
      ),
      data,
    );
  },
  // Update task assignee
  updateAssignee: (data: AssigneeUpdateTaskRequest) => {
    return apiClient.put<AssigneeUpdateTaskResponse, AssigneeUpdateTaskRequest>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.TASKS.UPDATE_ASSIGNEE(
          data.businessUnitId,
          data.taskId,
        ),
      ),
      data,
    );
  },
  // Update task by auditor
  auditorUpdate: (data: AuditorUpdateTaskRequest) => {
    return apiClient.put<AuditorUpdateTaskResponse, AuditorUpdateTaskRequest>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.TASKS.AUDITOR_UPDATE(
          data.businessUnitId,
          data.taskId,
        ),
      ),
      data,
    );
  },
  // Search tasks
  search: (data: SearchTasksRequest) => {
    return apiClient.post<SearchTasksResponse, SearchTasksRequest>(
      ServiceType.HELIOS,
      createApiUrl(API_ENDPOINTS.HELIOS_SERVICE.TASKS.SEARCH(data.businessUnitId)),
      data,
    );
  },
  // Cancel task
  cancel: (data: CancelTaskRequest) => {
    return apiClient.delete<CancelTaskResponse>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.TASKS.CANCEL(data.businessUnitId, data.taskId),
      ),
      data,
    );
  },
  // Create task
  create: (data: CreateTaskRequest) => {
    return apiClient.post<CreateTaskResponse, CreateTaskRequest>(
      ServiceType.HELIOS,
      createApiUrl(API_ENDPOINTS.HELIOS_SERVICE.TASKS.CREATE(data.businessUnitId)),
      data,
    );
  },
  // Create task from question
  createFromQuestion: (data: CreateTaskFromQuestionRequest) => {
    return apiClient.post<CreateTaskFromQuestionResponse, CreateTaskFromQuestionRequest>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.TASKS.CREATE_FROM_QUESTION(data.businessUnitId),
      ),
      data,
    );
  },
  // Get task stats
  getStats: (data: GetTaskStatsRequest) => {
    return apiClient.post<GetTaskStatsResponse, GetTaskStatsRequest>(
      ServiceType.HELIOS,
      createApiUrl(API_ENDPOINTS.HELIOS_SERVICE.TASKS.STATS(data.businessUnitId)),
      data,
    );
  },
  // Reopen task
  reopen: (data: ReopenTaskRequest) => {
    return apiClient.put<ReopenTaskResponse, ReopenTaskRequest>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.TASKS.REOPEN(data.businessUnitId, data.taskId),
      ),
      data,
    );
  },
};
